import { DEBUG, MOBILE_WIDTH, FORCE_CANVAS } from "./Constants";

export default function ticker(e) {

	this.reverse = this.scrollDepth > window.scrollY;

	let now = performance.now() || Date.now ();
	let elapsed = now - this.timestamp;
	this.timestamp = now;
	let delta = window.scrollY/1500 - this.scrollDepth/1500;

	let v = 1000 * delta / (1 + elapsed);
 	//this.velocity = this._ticker.fps < 20 ? 0 : Math.abs(0.8 * v + 0.2 * this.velocity);
	this.scrollDepth = window.scrollY;

	if (Math.abs(v) < 4.5	) {
		if (this.is_navigating) {
			this.is_navigating = false;
		}
	} else {
		this.is_navigating = true;
	}

	if (this.layoutManager.zoom_timer._call == null && this.queue.length > 0 && !this.layoutManager.mutex ) {
		if ( DEBUG ) console.group('pop', this.step);
		if (typeof this.last_animation !== 'undefined') {
			this.map_selector.classList.remove(`step-${this.last_animation.step}`);
			this.sections.classList.remove(`step-${this.last_animation.step}`);
		}
		let animation = this.queue.pop();
		this.last_animation = animation;
		this.map_selector.classList.add(`step-${animation.step}`);
		this.sections.classList.add(`step-${animation.step}`);
		Promise.resolve(animation.animate(true));
		if ( DEBUG )console.groupEnd();
	}

	this.elapsedTime += e;
	if(this.fpsDelta > 1) {
		if(this.elapsedTime>=this.fpsDelta) {
		 this.app.render();
		 this.elapsedTime = 0;
		}
	} else {
		this.app.render();
	}


}
